import { call } from 'redux-saga/effects';
import template from 'modal/request-swatch-email.j2';
import { replaceModalTransition } from '../../../core/js/actions/modalActions';

import { updateButtonTextSaga } from '../../../core/js/sagas/animateButtonSagas';

import { error } from '../../../core/js/utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

import { init as requestSwatchModalInit } from './productRequestSwatchModalComponent';
import { init as requestSwatchModalConfirmationInit } from './productRequestSwatchConfirmationModalComponent';
import { init as genericEmailServiceInit } from '../../../core/js/components/genericEmailServiceComponent';
import requestSwatchSignUpTemplate from 'modal/request-swatch-form.j2';

import { saveRequestSwatchFormData, resetRequestSwatchFormData, resetRequestSwatchSelections } from '../actions/productActions';
import { resetGenericEmailSuccessState, genericEmailServiceError } from '../../../core/js/actions/genericEmailServiceActions';

import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';

import { genericEmailServiceSaga } from '../../../core/js/sagas/genericEmailServiceSaga';

import { getOptionsForUpdateButton } from '../../../core/js/utils/requestUtils';

/* Override the default submit functionality that is in genericEmailServiceComponent */
function overrideGenericEmailSubmit(e, store) {
    const formSlug = $(e.target).attr('data-form-slug');
    const formData = $(e.target).serializeArray();
    const formElement = '.js-generic-email-override';

    const updateOptions = getOptionsForUpdateButton(store);

    let res = store.runSaga(updateButtonTextSaga, call(genericEmailServiceSaga, formData, formSlug), '.js-request-swatch-submit', 2000, updateOptions)
        .done.then(() => {
            const payload = replaceModalTransition(requestSwatchModalConfirmationInit, {}, e, this.name);

            $.event.trigger({
                type: payload.type,
                payload: payload
            });
            $(formElement).trigger('reset');
        }).catch((err) => {
            store.dispatch(genericEmailServiceError('GENERIC_EMAIL_SUBMIT_ERROR'));
            error(err);
        });
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-request-swatch-previous'), (e) => {
        e.preventDefault();
        const payload = replaceModalTransition(requestSwatchModalInit, {}, e, this.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });

    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-request-swatch-input'), _.debounce((e) => {
        const formData = { [e.target.name]: e.target.value };

        store.dispatch(saveRequestSwatchFormData(formData, this));
    }, 25));

    $(document).on(this.scopedEvent('submit'), '.js-generic-email-override', (e) => {
        e.preventDefault();

        // needs to be bound to the component because it references this.name
        overrideGenericEmailSubmit.bind(this)(e, store);
        return false;
    });
}

function addRequestSwatchShippingPageViewTracking(store) {
    const requestSwatchUtagData = {
        page_id: `${store.getState().core.localizations.containers.analyticsContainer.product_request_swatch_shipping_page_id}`,
        category_id: `${store.getState().core.localizations.containers.analyticsContainer.help_category_id}`
    };

    store.dispatch(handleUtagEvent(requestSwatchUtagData, 'view'));
}

function firstRender(store) {
    this.render(store, this);
    addRequestSwatchShippingPageViewTracking(store);
}

function afterCloseAction(store) {
    store.dispatch(resetRequestSwatchFormData());
    store.dispatch(resetRequestSwatchSelections());
    store.dispatch(resetGenericEmailSuccessState());
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            [genericEmailServiceInit, {
                template: requestSwatchSignUpTemplate
            }]
        ],
        attachEvents: attachEvents,
        firstRender: firstRender,
        template: template,
        name: 'modal.requestSwatchEmail',
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}
